<div class="flex gap-3 items-center p-4 bg-white rounded-lg">
  <p class="!font-bold mobile-hidden">
    {{ 'components.progressionBar.text' | transloco }}
  </p>
  <div
    [style.width.px]="progressBarSizeInPixel"
    class="h-2 rounded-xl bg-vinciBlue-100 relative"
  >
    <div
      [style.width.px]="progressWidth()"
      class="h-2 rounded-xl bg-vinciBlue-600 absolute"
    ></div>
  </div>
  <p class="!font-bold">{{currentProgress()}}</p>
</div>
